var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-2ef53153": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.268,
    height: 24.847,
    viewBox: "0 0 24.268 24.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-253.238 -514.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M277.343,524.272s.163,1.739.163,2.314c0,.607-.163,2.417-.163,2.417l0,.009a11.154,11.154,0,0,1-3.4,6.914l-4.009-3.019a7.767,7.767,0,0,0,.865-.666,5.329,5.329,0,0,0,1.653-3.229H265.68v-4.74h11.663Z",
    fill: "#4386f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M273.995,517.368l-3.567,3.511a7.292,7.292,0,0,0-4.659-1.859,7.565,7.565,0,0,0-7.144,5.082l-4.072-3.066a12.351,12.351,0,0,1,19.434-3.675Z",
    fill: "#ee4131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M273.939,535.926c-.013.012-.027.022-.04.035a12.582,12.582,0,0,1-19.363-3.85l4.078-3.072a7.568,7.568,0,0,0,11.316,3.868Z",
    fill: "#33a951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M258.614,529.039l-4.078,3.072a12.389,12.389,0,0,1,.017-11.075l4.072,3.066a7.593,7.593,0,0,0-.011,4.937Z",
    fill: "#ffbe00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.feef43ba33857a43f94df21f7c22eecb.svg";
export { ForwardRef as ReactComponent };